/* eslint-disable react/prop-types */
import React from 'react';
import {useEffect} from 'react';
import {useState} from 'react';
import {CONFIG_CONSTANT} from '../../../Constants/ConfigsConstants';
import {onApplyCoupon} from '../Actions/onApplyCoupon';

const OrderSummary = ({
  cart,
  cart_details,
  shippingMethod,
  setFullCartInfo,
  setIsLoading,
  selectedUser,
  pk_key,
}) => {
  const [coupon_code, setCouponCode] = useState('');

  useEffect(() => {
    if (cart?.coupon?.code) {
      setCouponCode(cart?.coupon?.code);
    }
  }, [cart]);

  const coupon_click = cart_id => {
    if (coupon_code) {
      onApplyCoupon({
        is_delete: cart?.coupon?.code ? true : false,
        coupon_code,
        cart_id,
        setFullCartInfo,
        setIsLoading,
        selectedUser,
        pk_key,
      });
    }
  };

  return (
    <div className="bg-white shadow-c-sm rounded-card p-4">
      <p className="text-primary text-xl leading-6 font-medium  ">
        Order Summary
      </p>

      {/* Coupon */}
      {CONFIG_CONSTANT.ORDERS_CONFIGS.enable_coupon && (
        <div className="flex items-center justify-center mt-5 gap-2">
          <input
            type="text"
            value={coupon_code}
            placeholder="Coupon value"
            className="
                  flex-grow
                    block
                    w-full
                     p-0
                     px-2
                     h-10
                    rounded-input
                    border
                    border-gray-300
                    focus:border-primary  
                    shadow-sm
                   "
            disabled={cart?.coupon?.code ? true : false}
            onChange={e => setCouponCode(e.target.value)}
          />
          <button
            className={[
              'flex-none btn-primary-outline px-2 h-10',
              coupon_code == '' ? 'cursor-not-allowed' : 'cursor-pointer',
            ].join(' ')}
            disabled={coupon_code == '' ? true : false}
            onClick={() => coupon_code !== '' && coupon_click(cart.id)}>
            {cart?.coupon?.code ? 'Remove Coupon' : 'Apply Coupon'}
          </button>
        </div>
      )}
      {cart?.coupon?.message && (
        <p className="text-sm font-medium   text-success  rounded card py-2   mt-1   ">
          {cart?.coupon?.message}
        </p>
      )}

      {/* Price Details */}
      <div className="mt-6">
        {/* */}
        {cart.pricing_items.length > 0 ? (
          <>
            {cart.pricing_items.map(pricing_item => {
              if (pricing_item?.display) {
                return (
                  <p
                    className={[
                      ' flex justify-between items-center mb-2 text-base leading-6 font-semibold text-default_gray',
                    ].join(' ')}>
                    <span>{pricing_item.name}</span>
                    <div className="flex items-center gap-2">
                      {pricing_item?.regular && (
                        <span className=" flex flex-wrap items-center    line-through">
                          <span
                            className={[
                              'text-base leading-6 font-semibold text-gray-600 ',
                            ].join(' ')}>
                            {pricing_item?.regular?.formatted}
                          </span>
                        </span>
                      )}
                      <span className=" flex flex-wrap items-center">
                        <span
                          className={[
                            'text-base leading-6 font-semibold ',
                            pricing_item?.type === 'sub_total'
                              ? ' text-black'
                              : pricing_item?.type === 'customer_coupon'
                              ? 'text-success'
                              : 'text-gray-600 ',
                          ].join(' ')}>
                          {pricing_item?.buying?.formatted}
                        </span>
                      </span>
                    </div>
                  </p>
                );
              }
            })}
            <p
              className={[
                ' flex justify-between items-center  text-xl leading-6 font-semibold text-black',
              ].join(' ')}>
              <span>Grand Total</span>{' '}
              <span className=" flex flex-wrap items-center">
                <span className="text-base leading-6 font-semibold text-black">
                  {cart.grand_total?.formatted}
                </span>
              </span>
            </p>
          </>
        ) : (
          <>
            <p className="text-base leading-6 font-semibold text-default_gray flex justify-between items-center mb-2">
              <span>Total</span>{' '}
              <span className=" flex flex-wrap items-center">
                <span className="text-base leading-6 font-semibold text-gray-600">
                  {cart.list_total?.formatted}
                </span>
              </span>
            </p>
            <p className="text-base leading-6 font-semibold text-default_gray flex justify-between items-center mb-2">
              <span>Shipping</span>{' '}
              <span className=" flex flex-wrap items-center">
                <span className="text-base leading-6 font-semibold text-gray-600">
                  {cart.shipping_total?.formatted}
                </span>
              </span>
            </p>
            <p className="text-xl leading-6 font-semibold text-black flex justify-between items-center">
              <span>Subtotal</span>{' '}
              <span className=" flex flex-wrap items-center">
                <span className="text-xl leading-6 font-semibold text-black">
                  {cart.grand_total?.formatted}
                </span>
              </span>
            </p>{' '}
          </>
        )}
      </div>
    </div>
  );
};

export default OrderSummary;
